/**
 * 2026-10-07 presence-states follow-up — pure state -> {variant, label}
 * mapping for the 4 connectivity.state values, shared by List.jsx and
 * Support.jsx so both surfaces render the same badge for the same state.
 */
export function connectivityBadge(state) {
  switch (state) {
    case 'online':
      return { variant: 'teal', label: 'Online' };
    case 'standby':
      return { variant: 'accent', label: 'Standby' };
    case 'app_closed':
      return { variant: 'gold', label: 'App Closed' };
    // Content/schedule facts layered on top of connectivity (Device Health
    // step 1): distinct from a red "Offline".
    case 'content_corrupted':
      return { variant: 'danger', label: 'Content Corrupted' };
    case 'scheduled_off':
      return { variant: 'muted', label: 'Scheduled Off' };
    case 'offline':
    default:
      return { variant: 'danger', label: 'Offline' };
  }
}
